const FUNDED_STATUSES = new Set([
  'Funded',
  'Funded from deal',
  'Funded (preview)',
  'Fully repaid',
]);

export function isFundedRoasCohortRow(row) {
  return FUNDED_STATUSES.has(row?.status);
}

function inferRevenueBasisFromCells(row) {
  let hasGross = false;
  let hasNet = false;
  for (const cell of row?.cells ?? []) {
    if (cell?.meetsThresholdGross != null) {
      hasGross = true;
    }
    if (cell?.meetsThresholdNet != null) {
      hasNet = true;
    }
  }
  if (hasGross && !hasNet) {
    return 'gross';
  }
  if (hasNet && !hasGross) {
    return 'net';
  }
  return null;
}

function revenueBasisForRow(row) {
  if (row?.revenueBasis === 'gross' || row?.revenueBasis === 'net') {
    return row.revenueBasis;
  }
  return inferRevenueBasisFromCells(row);
}

/**
 * Determines whether the gross/net toggle should be enabled for ROAS Cohort Performance.
 * Locks to a single view when all funded rows share one revenue basis.
 */
export function resolveRoasGrossNetViewPolicy(rows) {
  const fundedRows = (rows ?? []).filter(isFundedRoasCohortRow);
  if (fundedRows.length === 0) {
    return { toggleEnabled: true, view: null };
  }

  const bases = new Set(
    fundedRows
      .map(revenueBasisForRow)
      .filter((basis) => basis === 'gross' || basis === 'net')
  );

  if (bases.size === 1) {
    return { toggleEnabled: false, view: [...bases][0] };
  }

  return { toggleEnabled: true, view: null };
}
